var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnLinktree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-hub"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M10.327 12.1139V18H7.72949V12.1139H10.327ZM10.3176 0V4.39557L13.3103 1.31013L15.042 3.09494L11.8987 6.09494H16.3125V8.57278H11.8704L15.0326 11.6582L13.3009 13.3956L9.00941 9.06645L4.71791 13.3956L2.97683 11.6582L6.12959 8.57278H1.6875V6.09494H1.72514V6.08544H6.139L2.99566 3.08544L4.72732 1.30063L7.72008 4.38608V0L10.3176 0Z",
    fill: "#767A7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLinktree);
export default __webpack_public_path__ + "static/media/icn_linktree.cef47c5188eaf73f35c1b6ec33aaa497.svg";
export { ForwardRef as ReactComponent };